<template>
  <div>
    <AppBar v-if="this.$route.name !== 'loading'"></AppBar>
    <Content></Content>
    <Footer v-if="this.$route.name !== 'loading'"></Footer>
  </div>
</template>

<script>
import AppBar from "./components/appbar/AppBar";
import Content from "./components/Content";
import Footer from "./components/Footer";
export default {
  name: "PortalIndex",
  components: {
    Content,
    AppBar,
    Footer
  }
};
</script>

<style scoped></style>
